import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-nav-1",
  "use": "icon-icon-nav-1-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-icon-nav-1\"><path d=\"M814.208 725.312v35.584c0 39.104-32 71.104-71.04 71.104H245.248a71.04 71.04 0 0 1-71.04-71.104V263.04A71.04 71.04 0 0 1 245.248 192h497.792c39.104 0 71.104 32 71.104 71.104v35.584h-320c-39.424 0-71.04 32-71.04 71.04v284.48a71.04 71.04 0 0 0 71.04 71.104h320z m-320-71.04h355.584V369.728H494.208v284.416z m142.208-88.96a53.248 53.248 0 1 1 0-106.624 53.248 53.248 0 1 1 0 106.624z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/icon-nav-1.svg
// module id = pOuU
// module chunks = 3